module.exports = __webpack_public_path__ + "media/St 4-charging station-question.1abc3566.wav";